import React from "react";
import { Tooltip } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import ErrorIcon from "@mui/icons-material/Error";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

const STATUS_MAP = {
  OK: {
    tooltip: "Processamento concluído com sucesso.",
    icon: CheckCircleIcon,
    color: "#2e7d32",
  },
  PENDING: {
    tooltip: "Mídia na fila aguardando processamento.",
    icon: HourglassEmptyIcon,
    color: "#ed6c02",
  },
  PROCESSING: {
    tooltip: "Mídia em processamento no momento.",
    icon: AutorenewIcon,
    color: "#0288d1",
  },
  ERROR: {
    tooltip: "Falha no processamento da mídia.",
    icon: ErrorIcon,
    color: "#d32f2f",
  },
};

const fallbackStatus = {
  tooltip: "Status de processamento indisponível.",
  icon: HelpOutlineIcon,
  color: "#757575",
};

const ProcessingStatusField = ({ status, size = "small" }) => {
  const normalizedStatus = String(status || "").toUpperCase().trim();
  const statusConfig = STATUS_MAP[normalizedStatus] || fallbackStatus;
  const Icon = statusConfig.icon;
  const iconSize = size === "large" ? 24 : 20;

  return (
    <Tooltip title={statusConfig.tooltip} arrow>
      <Icon sx={{ color: statusConfig.color, fontSize: iconSize, verticalAlign: "middle" }} />
    </Tooltip>
  );
};

export default ProcessingStatusField;
